import { ONLINE_STATUS_THRESHOLD } from '@form-factory/shared';
import { useQuery } from '@tanstack/react-query';

import { useChatConfig } from '@/contexts/ChatConfigProvider';
import { aiCoreApi } from '@/services/aiCoreClient';
import { threadKeys } from '@/services/queryClient';

/**
 * Pings the API each X seconds to keep track of user activity and current
 * conversation mode.
 *
 * Additionally it provides callbacks to handle admin takeover.
 */
export function useActivityPing(
  threadId: string | undefined | null,
  interval = ONLINE_STATUS_THRESHOLD * 0.8,
) {
  const { chatId } = useChatConfig();

  /**
   * Ping the thread to keep track of user activity and current
   * conversation mode.
   */
  useQuery({
    queryKey: [...threadKeys.detail(threadId!)],
    queryFn: async () =>
      aiCoreApi.threads.ping({
        threadId: threadId!,
        chatId,
      }),
    refetchInterval: interval,
    enabled: !!threadId,
  });
}
